export enum MISSIONS_TABS {
    MISSIONS = 'missions',
    ACHIEVEMENTS = 'achievements',
}

export enum STATS_TABS {
    STATS = 'stats',
    HISTORY = 'history',
}
